import { h } from "@stencil/core";
export class GxgTest {
    constructor() {
        this.kbs = [];
    }
    el;
    watchKbsHandler() { }
    selectionHasChanged = e => {
        console.log(e.detail);
    };
    checkboxChanged = e => {
        console.log(e.detail);
    };
    updateKbs1 = () => {
        this.kbs = [
            {
                id: "uva",
                name: "uva",
                selected: false,
                disabled: false
            },
            {
                id: "manzana",
                name: "manzana",
                selected: true,
                disabled: false
            },
            {
                id: "pera",
                name: "pera",
                selected: false,
                disabled: false
            },
            {
                id: "sandia",
                name: "sandía",
                selected: false,
                disabled: true
            }
        ];
    };
    updateKbs2 = () => {
        this.kbs = [
            {
                id: "uva",
                name: "uva",
                selected: false,
                disabled: false
            },
            {
                id: "manzana",
                name: "manzana",
                selected: true,
                disabled: false
            },
            {
                id: "pera",
                name: "pera",
                selected: false,
                disabled: false
            },
            {
                id: "sandia",
                name: "sandía",
                selected: false,
                disabled: true
            }
        ];
    };
    updateKbs3 = () => {
        this.kbs = [
            {
                id: "uva",
                name: "uva",
                selected: false,
                disabled: false
            },
            {
                id: "manzana",
                name: "manzana",
                selected: false,
                disabled: true
            },
            {
                id: "pera",
                name: "pera",
                selected: true,
                disabled: false
            },
            {
                id: "sandia",
                name: "sandía",
                selected: true,
                disabled: true
            }
        ];
    };
    unselectLast = () => {
        this.kbs = [
            {
                id: "uva",
                name: "uva",
                selected: false,
                disabled: false
            },
            {
                id: "manzana",
                name: "manzana",
                selected: false,
                disabled: true
            },
            {
                id: "pera",
                name: "pera",
                selected: true,
                disabled: false
            },
            {
                id: "sandia",
                name: "sandía",
                selected: false,
                disabled: true
            }
        ];
    };
    singleSelectionChanged = e => {
        console.log(e.detail);
    };
    componentDidLoad() { }
    render() {
        return [
            h("div", null, h("p", null, "single selection"), h("gxg-list-box", { singleSelection: true,
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                part: "kbs", onSelectionChanged: this.singleSelectionChanged }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"], disabled: kb["disabled"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("p", null, "single selection allows empty"), h("gxg-list-box", { singleSelection: true,
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                allowsEmpty: true, onSelectionChanged: this.selectionHasChanged, part: "kbs" }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"], disabled: kb["disabled"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("p", null, "multi selection"), h("gxg-list-box", {
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                onSelectionChanged: this.singleSelectionChanged, part: "kbs"
            }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"], disabled: kb["disabled"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("p", null, "multi selection allows empty"), h("gxg-list-box", {
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                allowsEmpty: true, onSelectionChanged: this.selectionHasChanged, part: "kbs"
            }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"], disabled: kb["disabled"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("p", null, "disabled"), h("gxg-list-box", {
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                disabled: true, onSelectionChanged: this.selectionHasChanged, part: "kbs"
            }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("p", null, "with checkboxes"), h("gxg-list-box", {
                // disabled={this.selectionKbDisabled}
                // ref={(el: HTMLElement) => (this.listBoxEl = el)}
                checkboxes: true, onSelectionChanged: this.selectionHasChanged, onCheckedChanged: this.checkboxChanged, part: "kbs"
            }, this.kbs.map(kb => (h("gxg-list-box-item", { value: kb["id"], key: kb["id"], selected: kb["selected"] }, kb["name"]))))),
            h("br", null),
            h("div", null, h("button", { onClick: this.updateKbs1 }, "No selected"), h("button", { onClick: this.updateKbs2 }, "Second selected"), h("button", { onClick: this.updateKbs3 }, "Second & third selected"), h("button", { onClick: this.unselectLast }, "Unselect last"))
        ];
    }
    static get is() { return "gxg-test"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["test.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["test.css"]
        };
    }
    static get states() {
        return {
            "kbs": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "kbs",
                "methodName": "watchKbsHandler"
            }];
    }
}
//# sourceMappingURL=test.js.map
